<div class="container flex align-items-center justify-content-between px-3 md:px-5 py-3 md:py-4">
  @if (!sidebarService.isSidebarVisible() || sidebarService.isMobile()) {
    <div class="flex align-items-center">
      <button class="menu-toggle tap-target" (click)="sidebarService.toggle()">
        <i class="pi pi-angle-double-right"></i>
      </button>
      <div class="search-input ml-2">
        <ng-container *ngTemplateOutlet="search"></ng-container>
      </div>
    </div>
  } @else {
    <div class="search-input">
      <ng-container *ngTemplateOutlet="search"></ng-container>
    </div>
  }
  <div class="flex align-items-center">
    <app-button [btnSeverity]="ButtonSeverity.PRIMARY" [btnSize]="ButtonSize.MD" (btnClicked)="adminLocation.routeToCreateAppointment()">
      <app-calendar-plus-02 stroke="white"></app-calendar-plus-02>
      <div class="text-sm-semibold text-white btn-label">Dodaj rezervaciju</div>
    </app-button>
    <app-button class="ml-2-5 bell-button" [btnSeverity]="ButtonSeverity.SECONDARY" [btnSize]="ButtonSize.MD" (btnClicked)="adminLocation.routeToNotifications()">
      <app-bell-02 stroke="#181D27"></app-bell-02>
      @if (notificationService.unreadCount() > 0) {
        <span class="bell-badge" [attr.aria-label]="notificationService.unreadCount() + ' nepročitanih obaveštenja'"></span>
      }
    </app-button>
  </div>
</div>

<ng-template #search>
  <div class="autocomplete-with-icon">
    <i class="pi pi-search input-icon"></i>
    <p-autocomplete
      [autofocus]="false"
      #searchAutocomplete
      appendTo="body"
      [(ngModel)]="clientModel"
      [suggestions]="clientSuggestions()"
      [group]="true"
      optionLabel="name"
      optionGroupLabel="label"
      optionGroupChildren="items"
      placeholder="Pretraga"
      [forceSelection]="true"
      [showClear]="true"
      styleClass="w-full"
      inputStyleClass="with-icon with-kbd-hint w-full"
      panelStyleClass="admin-header-search-panel"
      (completeMethod)="searchClients($event)"
      (onSelect)="onClientSelected($event)"
    ></p-autocomplete>
    <span class="kbd-hint" aria-hidden="true">⌘K</span>
  </div>
</ng-template>
